<template>
  <div class="drop-zone" :class="{ item, hover: item && mouseInside }" v-mouse-move="mouseMove" v-mouse-leave="mouseLeave" v-mouse-up="mouseUp">
    <slot />
  </div>
</template>

<script>
export default {
  props: ['item'],
  data() {
    return {
      mouseInside: false,
    };
  },
  computed: {

  },
  methods: {
    mouseMove(event) {
      this.mouseInside = true;
      this.itemCopy = this.item;
      this.$emit('hover', this.itemCopy, event);
    },
    mouseLeave() {
      this.mouseInside = false;
      this.itemCopy = null;
    },
    mouseUp(event) {
      if (this.itemCopy) {
        var dropItem = this.itemCopy;
        this.itemCopy = null;
        console.log('DROPPING', dropItem);
        this.$emit('input', dropItem, event);
      }
    },
  },
  watch: {
    item() {
      setTimeout(() => this.itemCopy = this.item, 100);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisDropZone'] = this;
  },
}
</script>

<style lang="scss" scoped>
.drop-zone {
  &.item {
    border: 1px solid black;
  }

  &.hover {
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>